<template>
    <div :class="open ? 'open' : 'closed'" class="accordion">
        <div class="accordion-header">
            <button
                @click="toggleAccordion"
                @keydown.esc="open = false"
                :aria-expanded="open ? 'true' : 'false'"
                :aria-controls="bodyID"
                :id="headingID"
                class="accordion-title"
            >
                <slot name="accordion-header"></slot>
            </button>
        </div>

        <div v-show-slide="open" :aria-labelledby="headingID" :id="bodyID" class="accordion-body">
            <div class="accordion-content">
                <slot name="accordion-content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Accordion",

    data() {
        return {
            open: false
        }
    },

    computed: {
        headingID() {
            return lodash.uniqueId('accordion-heading-');
        },

        bodyID() {
            return lodash.uniqueId('accordion-body-');
        }
    },

    methods: {
        toggleAccordion() {
            this.open = !this.open
        }
    }
}
</script>

